import { useEffect, useState } from 'react';
import PageLoader from '../../../../../component/PageLoader';
import SendEmail from '../../../../components/SendEmail';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { fetchCreditNoteDetails, sendEmail } from '../../../../../services/sales_credit_note';

const SalesCreditNoteSendEmail = () => {
	const params = useParams();
	const { id } = params;
	const { userInfo } = useSelector((state) => state);
	const suburl = localStorage.getItem('suburl');
	const navigate = useNavigate();
	const [toEmails, setToEmails] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [creditNoteDetails, setCreditNoteDetails] = useState(null);
	const [emailFormData, setEmailFormData] = useState({
		from: '',
		to: [],
		subject: '',
		body: '',
		isAttachment: true,
	});

	async function handleSend(formData) {
		try {
			await sendEmail(id, formData);
			toast.success('Email Sent Successfully.');
			navigate(`/user/${suburl}/sales/credit-note`);
		} catch (error) {
			throw error;
		}
	}

	function handleClose() {
		navigate(`/user/${suburl}/sales/credit-note`);
	}

	async function handleFetchPRDetails() {
		try {
			setIsLoading(true);
			const { credit_note } = await fetchCreditNoteDetails({ ids: [Number(id)] });
			setCreditNoteDetails(credit_note);
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setIsLoading(false);
		}
	}

	useEffect(() => {
		if (id) {
			handleFetchPRDetails();
		}
	}, [id]);

	useEffect(() => {
		if (creditNoteDetails && userInfo) {
			const { credit_note_number, customer } = creditNoteDetails;

			var customerEmailList = [];
			var customerToSendEmailList = [];
			if (customer?.email) {
				customerEmailList.push(customer.email);
				customerToSendEmailList.push(customer.email);
			}
			setEmailFormData((prev) => ({
				...prev,
				to: customerToSendEmailList,
				from: `${userInfo?.userInfo?.data?.first_name} ${userInfo?.userInfo?.data?.last_name}`,
				subject: `Credit Note from ${userInfo?.userInfo?.data?.first_name + ' ' + userInfo?.userInfo?.data?.last_name} (Credit Note #: ${credit_note_number})`,
			}));
			setToEmails(customerEmailList);
		}
	}, [creditNoteDetails, userInfo]);

	if (isLoading) {
		return <PageLoader />;
	}

	return (
		<SendEmail
			pdfName="Credit Note"
			pdfId={`${creditNoteDetails?.credit_note_number}`}
			toEmails={toEmails}
			formData={emailFormData}
			handleSend={handleSend}
			handleClose={handleClose}
			isDropdownListShow={false}
		/>
	);
};

export default SalesCreditNoteSendEmail;
